import Base            from './base';
import events          from "../const/events";
import search          from '../const/search';
import $matchAllFilter from './../core/filter/matchAll';
import enUSLocale      from 'ro-webapp-backend/i18n/en-US';
import translation     from './../core/translate';

const log = require('debug')('ro:appState');

class App extends Base {
    constructor() {
        super();
        this.state = {
            online:            null, //bool
            installed:         null, //bool
            browser:           null, //object
            webp:              null, //bool
            settings:          {}, //object
            screens:           {}, //object
            locationAvailable: null,
            locationBlocked:   null,
            location:          null,
            activeScreen:      null, //object
            searchFilter:      $matchAllFilter, //function
            searchIn:          search.SEARCH_IN.PLANTS, //string
            lightbox:          null
        }
        translation.addDictionary('en-US', enUSLocale);
    }

    showImagesForPlantInLightbox(plntId) {
        this.setState({lightbox: {plantId: plntId}});
    }

    hideLightBox() {
        this.setState({lightbox: null});
    }

    setSearchIn(searchIn) {
        if (Object.values(search.SEARCH_IN).indexOf(searchIn) === -1) {
            console.warn('Unknown search in ', searchIn);
            return;
        }
        this.setState({searchIn: searchIn});
        this.emit(events.SEARCH.CHANGED, {searchFilter: this.state.searchFilter, searchIn});
    }

    setSearchFilter(searchFilter) {
        this.setState({searchFilter: searchFilter});
        this.emit(events.SEARCH.CHANGED, {searchFilter, searchIn: this.state.searchIn});
    }

    registerScreen(screenInstance) {
        let newScreens                  = {};
        newScreens[screenInstance.code] = screenInstance;
        this.setState({screens: Object.assign({}, this.state.screens, newScreens)});
    }

    setActiveScreen(screenInstance) {
        log(`Active screen set to ${screenInstance.code}`);
        if (screenInstance.appTitle) {
            document.title = screenInstance.appTitle;
        }
        this.setState({activeScreen: screenInstance});
        //TODO: chnage on screens not propagated anywhere!
        Object.keys(this.state.screens).map((screenCode) => {
            this.state.screens[screenCode].active = false;
        })
        screenInstance.active = true;
    }

    addLanguage(locale, language) {
        translation.addDictionary(locale, language);
    }

    setOnline(online) {
        this.setState({online: online});
    }

    getScreens() {
        return this.state.screens;
    }

    setWebPSupport(supported) {
        this.setState({webp: supported});
    }

    setInstalled(installed) {
        this.setState({installed: installed});
    }

    setBrowser(browser) {
        this.setState({browser: browser});
    }

    setSettings(settings) {
        this.setState({settings: settings});
    }

    getLocale() {
        return translation.locale;
    }

    setLocale(locale) {
        translation.setLocale(locale);
        this.emit(events.APPLICATION.LANGUAGE_CHANGED, locale); //TODO: maybe not needed, now only because catch lng change in components
    }
}

export default new App();


// WEBPACK FOOTER //
// ./src/state/app.js